/**
 * Copyright (c) 2018
 * @summary Checkbox Template
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React from 'react';
import { isEmpty } from 'lodash';
import { isFunction } from 'lodash/lang';

import Checkbox from '../../../../../common/data-entry/InputSelectors/Checkbox';
import Icon from '../../../../../common/general/Icon';
import { scBlue100 } from '../../../../../constants/systemColors';

class CheckboxTemplate extends React.Component {
  render({ props } = this) {
    return (
      <div
        className={
          props.customClassObject && props.customClassObject.containerClass
            ? props.customClassObject.containerClass
            : ''
        }
        style={{ ...props.styleForItem, display: 'flex', alignItems: 'center' }}
      >
        {props.showInvestigatorFieldIcon && (
          <Icon suit="material" style={{ fontSize: '25px' }}>
            medical_services
          </Icon>
        )}
        <Checkbox
          color={scBlue100}
          checked={!!(props.fullData && props.fullData.inputValue && JSON.parse(props.fullData.inputValue))}
          onChange={({ target: { checked } }) => {
            isFunction(props.onchangeCheckboxHandler) && props.onchangeCheckboxHandler(checked, props.fullData);
          }}
          id={'checkbox-id-' + this.props.templateData.uniqueIdentifier}
          disabled={props.disabled}
          label={
            this.props.templateData.updatedQuestion && !isEmpty(this.props.templateData.updatedQuestion.trim())
              ? this.props.templateData.updatedQuestion
              : this.props.templateData.question
          }
        />
      </div>
    );
  }
}

export default CheckboxTemplate;
